import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { isEqual } from 'lodash-es'
import Ul, { Li } from '../../ul'
import Dropdown from '../../tempDropdown'
import Icon from '../../../component/icon'
import './index.less'

const findItemByValue = (value, options = []) => {
  const item = options.find(m => isEqual(m.value, value))
  if (item) return item
  // eslint-disable-next-line no-shadow
  for (const item of options) {
    const sonItem = findItemByValue(value, item.children)
    if (sonItem) return sonItem
  }
}
export default (props) => {
  const { onChange, trigger, placement, overlayStyle, ...otherProps } = props
  const [visible, setVisible] = useState(false)
  const _onChange = (val) => {
    onChange?.(val)
    setVisible(false)
  }
  return <Dropdown
    overlayStyle={overlayStyle}
    trigger={trigger}
    overlay={<List {...otherProps} visible={visible} onChange={_onChange} />}
    visible={visible}
    onVisibleChange={_visible => setVisible(_visible)}
    placement={placement}
    getPopupContainer={false}
  >
    <Display {...otherProps} visible={visible} />
  </Dropdown>
}

const List = (props) => {
  const { className, options = [], value, onChange, visible, allowClear = true, header, footer } = props
  const [levels, setLevels] = useState([])
  useEffect(() => {
    setLevels(!value ? [] : getLevels(findItemByValue(value, options)))
  }, [visible])
  return <div className={classNames('mn-cascade', className)} onClick={e => e && e.stopPropagation()}>
    <Ul className="cascade-menu">
      {header}
      {allowClear ? <Li
        active={(value ?? undefined) === undefined}
        onClick={() => onChange(undefined)}
        onMouseEnter={() => setLevels([])}
      >不限</Li> : null}
      {options.map(item => <Li
        key={item.value}
        className={classNames('cascade-item', { active: isEqual(value, item.value) || levels.includes(item.value) })}
        onClick={() => !item.unSelectable && onChange?.(item.value)}
        onMouseEnter={() => setLevels([item.value])}
      >{item.label}</Li>)}
      {footer}
    </Ul>
    {levels.map((level, index) => {
      const o = findItemByValue(level, options).children
      if (!o) return null
      return <Ul className="cascade-menu">
        {o.map(item => <Li
          className={classNames('cascade-item', { active: isEqual(value, item.value) || levels.includes(item.value) })}
          onClick={() => !item.unSelectable && onChange?.(item.value)}
          onMouseEnter={() => setLevels(pre => [...pre.slice(0, index + 1), item.value])}
        >{item.label}</Li>)}
      </Ul>
    })}
  </div>
}

const Display = (props) => {
  const { value, options = [], placeholder = '请选择', visible, className, onClear, customText, onlyShowLeaf, ...otherProps } = props
  const getText = (item) => {
    let text = item.label
    if (onlyShowLeaf) { return text }
    if (item.parent) {
      const t = getText(item.parent)
      text = `${t}-${text}`
    }
    return text
  }
  const text = () => {
    const item = findItemByValue(value, options)
    if (!item) return undefined
    return getText(item)
  }
  return <a className={classNames('mn-cascade-display', className, { visible, active: (value ?? undefined) !== undefined })} {...otherProps}>
    <span className="text line-1">{customText?.() || text() || placeholder}</span>
    <Icon type="m-Vxing_xia" style={{ fontSize: 16, verticalAlign: 'text-bottom', transform: visible ? 'rotate(-180deg)' : undefined, transition: 'all 0.3s' }} />
  </a>
}

const getLevels = (item) => {
  if (!item) return []
  const levels = []
  if (item.parent) {
    levels.unshift(item.parent.value)
    const l = getLevels(item.parent)
    if (l.length) {
      levels.unshift(...l)
    }
  }
  return levels
}
